module.exports = __webpack_public_path__ + "static/media/boot.6c742ea1.svg";